import AsyncSelect from 'react-select/async';
import SectorApi from 'api/sector';

const SectorSelect = props => {
  const loadOptions = (input_value, callback) => {
    SectorApi.fetch().then(data => {
      const options = data.map(item => {
        return {
          value: item.id,
          label: item.name,
          ...item,
        };
      });

      callback(options.filter(item => item.name.toLowerCase().includes(input_value.toLowerCase())));
    });
  };

  return <AsyncSelect placeholder="Setor" classNamePrefix="select" cacheOptions defaultOptions loadOptions={loadOptions} {...props} />;
};

export default SectorSelect;
